export var STYLE_STICKER = 'sticker';
export var STYLE_ROSE = 'rose';
export var IMAGE_STYLES = [STYLE_STICKER, STYLE_ROSE];